import React from 'react';
import { SafeAreaView, View, Text, StyleSheet, ImageBackground } from 'react-native';
import HeaderWithSatatusBar from './HeaderWithSatatusBar';
import { StatusBar } from 'expo-status-bar';

const CommonPage = ({ children, headerText, drawerIconVisible, userBalance, balfetching }) => {
  return (
    <SafeAreaView style={styles.container}>
        <HeaderWithSatatusBar headerText={headerText} drawerIconVisible={drawerIconVisible} userBalance={userBalance} balfetching={balfetching}/>
        <ImageBackground 
        source={require('../../assets/astrobackground.png')} 
        style={styles.background}
      >
        <View style={styles.content}>
          {children}
        </View>
      </ImageBackground>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  background: {
    width: '100%',
        flex: 1,
  },
  content: {
    width: '100%',
    flex: 1,
  }
});

export default CommonPage;
